module.exports = __webpack_public_path__ + "static/akzent-f-es-34c1f0ee590dbae4e2cb1e86270dbc4e.png";